import * as T from '../../../components/Table'
import { Item } from './Item'

export function ListItem({ list }) {
  return (
    <T.Tbody>
      {list?.map((item, index) => (
        <Item key={index} item={item} />
      ))}
    </T.Tbody>
  )
}
